import OryClient from '../api/OryClient';

const { REACT_APP_ACCOUNTS_BASE_URL: ACCOUNTS_URL } = process.env;
const { REACT_APP_CLIENT_ROOT: NISO_ROOT } = process.env;

const getOrySession = async () => {
  const { data } = await OryClient.toSession();
  const logoutUrl = '';
  return { session: data, logoutUrl };
};

// eslint-ignore no-return-assign
const orySessionCreate = () =>
  window.location.assign(`${ACCOUNTS_URL}/customers/sign-in?returnTo=${NISO_ROOT}`);

const orySessionDestroy = async () => {
  try {
    const { data: flow } = await OryClient.createBrowserLogoutFlow();
    await OryClient.updateLogoutFlow({
      token: flow.logout_token,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
};

export default class AuthService {
  constructor() {
    this.handleLogin = orySessionCreate;
    this.session = getOrySession;
    this.handleLogout = orySessionDestroy;
  }

  login() {
    return this.handleLogin();
  }

  logout() {
    return this.handleLogout();
  }

  getSession() {
    return this.session();
  }
}
